module.exports = __webpack_public_path__ + "static/img/shenfenzhengbeimian.f34bfcf2.png";